import { render, staticRenderFns } from "./stockHistory.vue?vue&type=template&id=b0787a90&scoped=true&"
import script from "./stockHistory.vue?vue&type=script&lang=js&"
export * from "./stockHistory.vue?vue&type=script&lang=js&"
import style0 from "./stockHistory.vue?vue&type=style&index=0&id=b0787a90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0787a90",
  null
  
)

export default component.exports